import ViewContainer from './ViewContainer'

import _AllViewContainer from './AllViewContainer'
import _FormViewContainer from './FormViewContainer'

export const AllViewContainer = _AllViewContainer
export const FormViewContainer = _FormViewContainer

export default ViewContainer
